import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { getConfigs, isApiError } from "src/util/apiNew";
import { tReduxAction } from "../types";

const loadConfigs = (): tReduxAction => {
  return async (dispatch) => {
    try {
      const configs = await getConfigs();
      dispatch({ type: "SET_CONFIGS", payload: configs });
    } catch (error) {
      if (isApiError(error)) {
        dispatch({ type: "SET_CONFIGS_ERROR", payload: error });
      }
    }
  };
};

export const useLoadConfigs = (): null => {
  const dispatch = useAppDispatch();
  const isUserLoading = useSelector((state) => state.LoadingReducer.userFetching);

  React.useEffect(() => {
    if (!isUserLoading) {
      dispatch(loadConfigs());
    }
  }, [dispatch, isUserLoading]);

  return null;
};
